import cheader from '@/components/header/index.vue'
import caside from '@/components/aside/index.vue'

export default {
  name: 'user_good_create',
  data() {
    return {
      total: 0,
      curpage: 1,
      cates: [],
      brands: [],
      presclass: [],
      codeFormVisiable: false,
      goods2: [],
      search2: {
        name: '',
        manufacturer:"",
        recnumber:"",
        type:""
      },
      total2: 0,
      curpage2: 1,
      page2: 1,
      form: {
        image: [],
        userId: this.$store.state.user.id,
        spid: ''
      },
      rules: {
        name: {
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        },
        brand: {
          required: false,
          message: '请选择品牌',
          trigger: 'change'
        },
        cates: {
          required: false,
          message: '请选择产品分类',
          trigger: 'change'
        },
        code: {
          required: false,
          message: '请输入助记码',
          trigger: 'blur'
        },
        numbering: {
          required: false,
          message: '请输入产品编码',
          trigger: 'blur'
        },
        recnumber: {
          required: true,
          message: '请输入批准文号',
          trigger: 'blur'
        },
        manufacturer: {
          required: true,
          message: '请输入生产厂家',
          trigger: 'blur'
        },
        specification: {
          required: true,
          message: '请输入产品规格',
          trigger: 'blur'
        },
        presclass: {
          required: false,
          message: '请选择处方分类',
          trigger: 'change'
        },
        formulation: {
          required: false,
          message: '请输入剂型',
          trigger: 'blur'
        },
        prounit: {
          required: false,
          message: '请输入产品单位',
          trigger: 'blur'
        },
        spid: {
          required: true,
          message: '请输入ERP商品ID',
          trigger: 'blur'
        },
        bagShl: {
          required: true,
          message: '请输入件包装',
          trigger: 'blur'
        },
        mbagShl: {
          required: true,
          message: '请输入中包装',
          trigger: 'blur'
        },
        dmname: {
          required: false,
          message: '请输入对码商品',
          trigger: 'blur'
        }
      },
    }
  },
  created() {
    this.cateIndex()
    this.brandIndex()
    this.presclassIndex()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    cheader,
    caside
  },
  methods: {
    code() {
      this.codeFormVisiable = true
      
      this.search2.type = "search"
      this.$http.get('api/ucenter/productPublic', {
        params: {
          userId: this.user.id,
          search: this.search2,
          page: this.page2,
          pageSize: 10
        }
      }).then((res) => {

        res.data.data = res.data.data ? res.data.data : []

        for (let item of res.data.data) {

          item.glid = item.glid != undefined ? '已对码' : '未对码'

          if (item.image == '') {
            item.image = []
          } else {
            if (!item.image) {
            } else {
              item.image = item.image.split('|')
            }
          }
          if (item.cates == '') {
            item.cates = []
          } else {
            if (!item.cates) {


            } else {
              item.cates = item.cates.split(',')
            }
          }
          if (item.brand) {
            item.brand = item.brand.id
          } else {
            item.brand = ''
          }
        }
        this.goods2 = res.data.data
        this.total2 = res.data.total
      });
    },
    code2(page) {
      this.page2 = page
      this.search2.type = "search"
      this.$http.get('/api/ucenter/productPublic', {
        params: {
          userId: this.user.id,
          search: this.search2,
          page: page,
          pageSize: 10
        }
      }).then((res) => {


        res.data.data = res.data.data ? res.data.data : []

        for (let item of res.data.data) {

          item.glid = item.glid != undefined ? '已对码' : '未对码'

          if (item.image == '') {
            item.image = []
          } else {
            if (!item.image) {
            } else {
              item.image = item.image.split('|')
            }
          }
          if (item.cates == '') {
            item.cates = []
          } else {
            if (!item.cates) {


            } else {
              item.cates = item.cates.split(',')
            }
          }
          if (item.brand) {
            item.brand = item.brand.id
          } else {
            item.brand = ''
          }
        }
        this.goods2 = res.data.data
        this.total2 = res.data.total
      })
    },
    match2() {

    },
    match(info) {
      this.form.glid = info.id
      this.form.dmname = info.name
      this.form.name = info.name
      this.form.code = info.zjm
      this.form.numbering = info.numbering
      this.form.recnumber = info.recnumber
      this.form.manufacturer = info.manufacturer
      this.form.specification = info.specification
      this.form.formulation = info.formulation
      this.form.prounit = info.prounit
      this.form.mbagShl = info.mbagShl
      this.form.bagShl = info.bagShl
      this.codeFormVisiable = false;
    },
    async opd() {
      this.codeFormVisiable = true;
      this.code()
    },
    cateIndex() {
      this.$http.get('/api/category').then((res) => {
        this.cates = res.data.data
      })
    },
    brandIndex() {
      this.$http.get('/api/brand').then((res) => {
        this.brands = res.data.data
      })
    },
    presclassIndex() {
      this.$http.get('/api/chuffl').then((res) => {
        this.presclass = res.data.data
      })
    },
    uploadImage(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post('/api/fileUpload', formData).then((res) => {
        if (res.data.success) {
          this.form.image.push(res.data.message)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$http.post('/api/ucenter/productAdd', this.form).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message)
              window.setTimeout(() => {
                this.$router.push('/user/good')
              }, 1500)
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/user/good/create/index.js